module.exports = __webpack_public_path__ + "img/img-header.97091ec.webp";